// Lien Outlook Bookings d'Ariovis (Matthieu Filizzola)
export const BOOKING_URL =
  "https://outlook.office.com/bookwithme/user/24a4c744ca1c4170999f0b5d4a34f631@ariovis.fr?anonymous&ismsaljsauthenabled&ep=plink";
